import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface ICheckConnectionParams {
  id: string;       // Data source id
  server?: string;
  port?: string;
  username?: string;
  embedPassword?: boolean;
  password?: string;
  encryptedPassword?: string;
  encryptedPasswordKeyId?: string;
  // W-22482525: Workload Identity Federation connection check.
  workgroupAuthMode?: string;
  authFederationServiceAccount?: string;
}

export interface ICheckConnectionResult extends IResult {
  succeeded: boolean;
  messages: string[]; // Messages are strings from the DataSourceException thrown and will not be localized.
}

export class CheckConnectionRequest extends Request<ICheckConnectionParams, ICheckConnectionResult> {
  constructor(params: ICheckConnectionParams) {
    super('checkConnection', params);
  }
}
